module.exports = "pegasus/assets/impact-card.png";